import React, { useEffect, useRef, useState } from "react";

export const Reveal = ({ as: Tag = "div", delay = 0, className = "", children, ...rest }) => {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    // Safety fallback: no matter what, reveal after 1.2s so content is never
    // permanently invisible (e.g. tall articles where IntersectionObserver's
    // ratio can't reach the threshold, or browsers without IO support).
    const failsafe = setTimeout(() => setShown(true), 1200 + delay);

    if (typeof IntersectionObserver === "undefined") {
      setShown(true);
      return () => clearTimeout(failsafe);
    }

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setTimeout(() => setShown(true), delay);
            obs.unobserve(node);
          }
        });
      },
      // threshold 0 = any pixel visible triggers; safe for elements taller
      // than the viewport (long articles). rootMargin nudges trigger up a bit.
      { threshold: 0, rootMargin: "0px 0px -5% 0px" }
    );
    obs.observe(node);
    return () => {
      clearTimeout(failsafe);
      obs.disconnect();
    };
  }, [delay]);

  return (
    <Tag
      ref={ref}
      className={`reveal ${shown ? "in" : ""} ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
